<template>
  <Modal v-model="myInventoryDetailsModal" :title="$t('key1002938')" width="1000" :transfer="false"
    :mask-closable="true" @on-visible-change="myInventoryDetailsChange">
    <div class="table-box">
      <Table
        highlight-row
        border
        max-height="550"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      class="distributor-page-box"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <template #footer>
      <Button type="primary" @click="myInventoryDetailsModal = false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {isValueEmpty} from "@/utils/common";

export default {
  name: 'myInventoryDetailsModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      myInventoryDetailsModal: false,
      pageParams: {
        ymsInventoryId: null,
        ymsProductGoodsId:null,
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          type: 'index',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'),
          width: 70,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005653'),
          key: 'recentSales',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let type = params.row.type; // 1.采购到货 2.分配库存 3.取消订单 5.库存盘点
            let typeList = [
              {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005654')},
              {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005655')},
              {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004290')},
              {value: 5, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005656')}
            ];
            let text = '';
            typeList.map((item) => {
              if (item.value === type) {
                text = item.name;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000740'),
          key: 'myAvailableInventory',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            let curAvailableNumber = params.row.curAvailableNumber;
            let originalAvailableNumber = params.row.originalAvailableNumber;
            let inventory = curAvailableNumber - originalAvailableNumber;
            return h('span', inventory);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000743'),
          key: 'curAvailableNumber',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000748'),
          key: 'relatedBusinessNo',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005657'),
          key: 'updatedTime',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            let updatedTime = params.row.updatedTime;
            let time = updatedTime ? v.$uDate.dealTime(updatedTime, 'fulltime') : '-';
            return h('span', time);
          }
        },
      ],
      tableData: [],
    };
  },
  computed: {},
  created() {

  },
  methods: {
    // 初始化数据
    initMyInventoryDetailsData(obj) {
      this.pageParams.ymsInventoryId = obj.ymsInventoryId;
      this.pageParams.ymsProductGoodsId = obj.ymsProductGoodsId;
      this.myInventoryDetailsModal = true;
      this.getList();
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.tableLoading = true;
      v.tableData = [];
      v.total = 0;
      v.axios.post(api.post_ymsDistributorInventory_details, v.pageParams).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.tableData = data.list || [];
            v.total = data.total;
          }
        }
      });
    },
    // 监听弹窗
    myInventoryDetailsChange(val) {
      if (!val) {
        this.tableData = [];
        this.pageParams.ymsInventoryId = null;
        this.pageParams.ymsProductGoodsId = null;
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
};
</script>

<style lang="less">

</style>
